import { render, staticRenderFns } from "./PrivacyGuideSpamMessage.vue?vue&type=template&id=8fb65f26&scoped=true"
import script from "./PrivacyGuideSpamMessage.vue?vue&type=script&lang=js"
export * from "./PrivacyGuideSpamMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb65f26",
  null
  
)

export default component.exports